<template>
  <nav class="navbar navbar-expand">
    <div class="container-fluid">
      <a class="navbar-brand text-site-white">
        <span
          class="d-md-none  me-2"
          v-on:click="openSideDrawer"
          style="cursor: pointer"
        >
          <i class="fas fa-bars"></i>
        </span>
        Kabbik Admin</a
      >
      <div>
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img :src="profileImage" class="user_img" />
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end bg-dark"
              aria-labelledby="navbarDropdown"
            >
              <li>
                <router-link to="/profile" class="dropdown-item text-white"
                  ><i class="fas fa-sliders-h me-2"></i> Profile</router-link
                >
              </li>
              <li><hr class="dropdown-divider text-white" /></li>
              <li>
                <a
                  class="dropdown-item text-white"
                  v-on:click="logout"
                  href="javascript:void(0)"
                  ><i class="fas fa-sign-out-alt me-2"></i>Logout</a
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Header",
  data(){
    return{
      profileImage: localStorage.getItem(this.$profileImage),
    }
  },
  methods: {
    openSideDrawer: function () {
      document.getElementById("mobile_sidebar").style.left = "0";
      document.getElementById("mobile_sidebar").style.transition = "1s";
      document.getElementById("side-drawer-void").classList.add("d-block");
      document.getElementById("side-drawer-void").classList.remove("d-none");
    },
    logout() {
      localStorage.clear();
      this.$router.push("/login");
    },
    // closeSideDrawer: function() {
    //   document.getElementById("side-drawer").style.left = "-100%";
    //   document.getElementById("side-drawer").style.transition = "2s";
    //   document.getElementById("side-drawer-void").classList.add("d-none");
    //   document.getElementById("side-drawer-void").classList.remove("d-block");
    // }
  },
};
</script>
<style scoped>
.text-site-white{
  color: #ffffff!important;
}
@media (min-width: 767px) {
  .text-site-white{
    color: #000000!important;
  }
}
</style>
